import React, { useEffect } from 'react';
import {ReactComponent as UploadImg} from '../../../assets/new-icons/uploadImg.svg';
import {ReactComponent as Edit} from '../../../assets/new-icons/edit.svg';
import {ReactComponent as RemoveImg} from '../../../assets/new-icons/close.svg';
import ConfermaBTN from '../../ConfermaBTN/ConfermaBTN'
import { useSelector } from 'react-redux';
import md5 from 'md5';
import { useFetchLogin } from '../../../functions/login';

function EditInfo({setEditInfo}) {
  const [check, setCheck] = React.useState(null)
  const [checkPas, setCheckPas] = React.useState(false)
  const [pas1, setPas1] = React.useState()
  const maxNumber = 69;
  const [state, setState] = React.useState({
    username: null,
    cell: null,
    email: null,
    password: null,
  })
  const customerId = useSelector((user) => user.user.info.customer_id)
  const userId = useSelector((user) => user.user.info.user_id)
  const tkn = md5(customerId + 'oYmAIdtki%lu') 
  const fullName = useSelector((user) => user.user.info.customer_full_heading)
  const firstName = fullName.split(' ').slice(0, -1).join(' ')
  const apiUsr = `https://my.revoluce.it/area_utente/gestione/api/customers/setProfile.php?username=${state.username}&cell=${state.cell}&email=${state.email}&password=${state.password}&customer_id=${customerId}&user_id=${userId}&tkn_pvt=${tkn}`;
  const fetchLogin = useFetchLogin()


  function checkPassword(str){
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      setCheck(re.test(str))
      if(re.test(str)){
        setPas1(str)
      }

  }

  const handleField = (e) => {
    setState(prevState => ({...prevState, [e.name]: e.value})) 
  }
  const handleLocalStorage = () => {
    setEditInfo(false)
  }
  useEffect(() => {
    if(state.username){
      localStorage.setItem('username', state.username)
    }
  },[state.username])

  useEffect(() => {
    if(state.password){
      localStorage.setItem('password', state.password)
    }
  },[state.password])

  return (
      <>
        <div className="text">
            <p className="main">Modifica i tuoi dati</p>
            <p className="secondary">
                Modifica i dati relativi al tuo account e clicca su "Salva" per aggiornarli.
            </p>
        </div>

        <div className="editImage">
            <div className="upload__image-container">
              <div className="upload__image-wrapper">
                  <img src={`https://avatars.dicebear.com/api/bottts/${firstName}.svg`} alt="foto profilo" />
              </div>
            </div>
        </div>
        <div className="editFields">
          <div className="item">
            <p className="label">Username</p>
            <div className='input'>
              <input autocomplete="false" name="username" type="text" placeholder='username' onChange={(e) => handleField(e.target)} />
              <Edit />
            </div>
          </div>
          <div className="item">
            <p className="label">Email</p>
            <div className="input">
              <input autocomplete="false" name="email" type="email" placeholder='Email' onChange={(e) => handleField(e.target)}></input>
              <Edit />
            </div>
          </div>
          <div className="item">
            <p className="label">Telefono</p>
            <div className="input">
              <input autocomplete="false" name="cell" type='tel' placeholder='Telefono' onChange={(e) => handleField(e.target)}></input>
              <Edit />
            </div>
          </div>
        </div>
        <div className="editPassword">
          <div className="text">
              <p className="main">Modifica password</p>
              <p className="secondary">
                Crea una password per il tuo account. Assicurati che abbia almeno 8 caratteri, un numero e un carattere speciale.
              </p>
          </div>
          <div className="item">
            <p className="label">Nuova Password</p>
            <div className="input">
              <input autocomplete="false" style={check ? {borderColor: '#5AD8A6'} : check === null ? {borderColor: '#DCDCDC'} : {borderColor: '#FF0038'}} onChange={(e) => checkPassword(e.target.value)} type="password" placeholder='Password'></input>
              <Edit />
            </div>
          </div>
          {check ? (
            <div className="item">
              <p className="label">Conferma Password</p>
              <div className="input">
                <input autocomplete="false" name="password" style={checkPas ? {borderColor: '#5AD8A6'} : {borderColor: '#FF0038'}} onChange={(e) => e.target.value === pas1 ? (handleField(e.target), setCheckPas(true)) : setCheckPas(false)} type="password" placeholder='Conferma Password' />
                <Edit />
              </div>
            </div>
          ) : null}
        </div>
        <ConfermaBTN text="Conferma" confermTxt="Confermi di voler aggiornare i tuoi dati?" url={apiUsr} forward="/enrica/profilo" customFunc={handleLocalStorage} sectionComponent="editProfile" />
      </>
  );
}

export default EditInfo;
